module.exports = __webpack_public_path__ + "static/images/components/Confirmation/images/close.2100b800.png";


//////////////////
// WEBPACK FOOTER
// ./components/Confirmation/images/close.png
// module id = 2595
// module chunks = 11